import React from 'react';
import {Filter, TextInput, FilterProps} from 'react-admin';

const ShapeFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <TextInput source="code" alwaysOn/>
        <TextInput source="name" alwaysOn/>
    </Filter>
);

export default ShapeFilter;
